export const errorFr = {
    forbidden: 'Accès refusé',
    notFound: "Aucune donnée n'a été trouvée",
    refreshError: 'Impossible de rafraichir votre session',
    serverConnectionFailed: 'Connexion au serveur échouée',
    sessionExpired: 'Session expirée',
    unknownError: 'Une erreur inconnue est survenue'
}
